<template>
  <div class="box">
    <div
      contenteditable="true"
      class="${ww} ww"
      @mouseover="styleOver($event)"
      @mouseout="styleOut($event)"
      @input="changeText($event)"
    >123</div>
    <div class="${ww} ww" @mouseover="getItem1($event)">123</div>
    <div
      class="lef"
      v-html="str2"
      ref="viewBox"
      @mouseover="styleOver($event)"
      @mouseout="styleOut($event)"
      @input="changeText($event)"
    ></div>
    <!-- <qw v-model='qq'></qw>
        <div id="lef" class="box">
<div :class="activeClass == index ? 'active':''" v-for="(item,index) in ary" :key="index" @mouseover="getItem(index)">
          <span  contenteditable="true" v-for="(itm,i) in item" :key="i">{{itm}}</span>
        </div>
        </div>
        
        <div id="rig" class="box">
<div :class="activeClass == index ? 'active':''" v-for="(item,index) in ary" :key="index" ref="arr"  @mouseover="getItem(index)">
          <span contenteditable="true" v-for="(itm,i) in item" :key="i" @input="changeText($event,itm.b,index,i)">{{itm.a}}</span>
        </div>
    </div>-->
    <!-- <button @click="qqq">123</button> -->
    <!-- <div
      class="qq1"
      id="qq"
      contenteditable="true"
      @input="changeText($event,index,i)"
      @mouseover="getItem2($event)"
    >
      <div>{{str}}</div>
    </div>
    <div
      class="qq1"
      id="qq"
      contenteditable="true"
      @input="changeText($event,index,i)"
      @mouseover="getItem1($event)"
    >
      
    </div>-->
    <div class="rig" v-html="str" ref="viewBox2"></div>
    <button @click="getItem2"></button>
    <input type="text" @input="changeText($event)" />
  </div>
</template>

<script>
// import qw from "@/components/pay/qwe.vue";

// import { setTimeout } from 'timers';

export default {
  data() {
    return {
      text: "改一下试一试",
      str2: "",
      str: "<div><span>101,</span><span>147,</span></div><div>asdada</div>",
      // ary:[["as111111111111"],["m","l"]],
      ary: [
        [{ a: "as111111111111", b: "222222222" }],
        [{ a: "August", b: "八月" }, { a: "rr", b: "sss" }]
      ],
      arr: [["中发白"], ["m", "l"]],
      activeClass: "",
      scroll: ""
    };
  },
  created() {
    //  this.qq = "<div><span>101</span><span>147</span></div><div>asdada</div>"
    var that = this;
    that.getItem2();
    that.str = "111";
    this.catReq1Service("/demo/html_str", {
          type: 1002
      },"get")
      .then(function(response) {
          if (!response.success) {
            return
          }
        var errorCode = response.errorCode;
        if (errorCode == "CAT-V004" || errorCode == "CAT-V003") {
          that.$router.push({ name: "login" });
          return;
        }
        if (response.resultCode === "0") {
          that.$message({
            message: `${response.errorDesc}(${errorCode})`,
            type: "warning"
          });
          return;
        }
        // console.log(response.data);
        var regex = /&lt;/g;
        var regex1 = /&gt;/g;
        var qwe = response.match(/<body>(.*?)<\/body>.*$/i)[1];
        var qwe2 = qwe.replace(regex, "<");
        var qwe3 = qwe2.replace(regex1, ">");
        // // qweee = qwe3
        // console.log(qweee,"///////////////")
        that.str2 = qwe3;
      })
      .catch(function(error) {
        that.$message({
          message: "网络出错!",
          type: "error"
        });
      });
  },
  updated() {
    console.log(this.arr);
  },
  components: {
    // qw
  },
  mounted() {
    var that = this;
    // 通过$refs获取dom元素
    that.box = that.$refs.viewBox;
    // 监听这个dom的scroll事件
    that.box.addEventListener(
      "scroll",
      () => {
        console.log(" scroll " + that.$refs.viewBox.scrollTop);
        console.log(" scroll ", that.$refs.viewBox.scrollHeight);
        //  that.isScroll=that.$refs.viewBox.scrollTop>0
        var scrollHe =
          that.$refs.viewBox.scrollHeight / that.$refs.viewBox2.scrollHeight;
        that.$refs.viewBox2.scrollTop = that.$refs.viewBox.scrollTop * scrollHe; // 滚动条改变
      },
      false
    );
  },
  methods: {
    scrollDs() {
      this.scroll = document.body.scrollTop;
      console.log(this.scroll);
    },
    changeText(event) {
      //       var timer; // 维护同一个timer
      //       var qq = "1"
      // if(qq) {
      //   //  clearTimeout(timeout);
      //       qq = "0"
      //       setTimeout(() => {
      //         console.log(event.target.className, "/////////");
      //       console.log(event.target.innerText, "/////////");
      //       }, 3000);
      // let timeout = null;
      // //  clearTimeout(timeout)
      // //  return function() {
      // if (timeout !== null) clearTimeout(timeout);
      // timeout = setTimeout(() => {
      //   function name(params) {
      if (condition) {
      }
      console.log(event.target.value, "/////////");
      console.log(event.target.innerText, "/////////");
      console.log(event.target.innerText, "/////////");

      //   console.log(event.target.innerText, "/////////");
      //   timeout = 1
      //   }
      // }, 3000);
      //  let timer=1 ;
      //       if(timer){
      //           clearTimeout(timer)
      //       }
      //       timer = setTimeout(function () {
      //           console.log('输入')
      //           timer = undefined;
      //       },2000)

      // }
    },
    styleOut(e) {
      // alert(1)
      if (e.target.className[0]) {
      }
      var qwe = document.getElementsByClassName(e.target.className);
      for (let index = 0; index < qwe.length; index++) {
        console.log(qwe[index].style.backgroundColor, "/////////");
        qwe[index].style.backgroundColor = "white";
      }
    },
    getItem2() {
      var that = this;
      this.catReq1Service("/demo/html_str", {
            type: 1001
        },"get")
        .then(function(response) {
          if (!response.success) {
            return
          }
          // console.log(response.data);
          
          var regex = /&lt;/g;
          var regex1 = /&gt;/g;
          var qwe = response.match(/<body>(.*?)<\/body>.*$/i)[1];
          var qwe2 = qwe.replace(regex, "<");
          var qwe3 = qwe2.replace(regex1, ">");
          // qweee = qwe3
          // console.log(qweee,"///////////////")
          that.str = qwe3;
        });

      // alert(2)
      // this.activeClass = index; // 把当前点击元素的index，赋值给activeClass
      // document.getElementsByClassName("qq1").style.backgroundColor= "red"
    },
    styleOver(e) {
      console.log(e.target.className[0], "///??????????//////");
      if (e.target.className[0] == "$") {
        var qwe = document.getElementsByClassName(e.target.className);
        for (let index = 0; index < qwe.length; index++) {
          console.log(qwe[index].style.backgroundColor, "/////////");
          qwe[index].style.backgroundColor = "red";
        }
      }
      // document.getElementsByClassName("${ww}").innerHTML = "55这是啥";

      console.log(e.target.className, "/////////");
    },
    // qqq(){
    //   var reg = new RegExp("<body>(.|\s|\r|\n|\f)*</body>");
    // },
    qqq() {
      // var reg = new RegExp("(?i)[\\s\\S]*\\<body\\>([\\s\\S]*)\\<\\/body\\>[\\s\\S]*");
      var a =
        '<html><body>&lt;span&gt;${0_0}&lt;/span&gt; <span>1215555555</span> <font   style="color:red"> bbb </font></body></html>';
      // alert(a.replace(/<body>(.*?)<\/body>.*$/i,"$1"))
      var regex = /&lt;/g;
      var regex1 = /&gt;/g;

      console.log(a.match(/<body>(.*?)<\/body>.*$/i)[1]);
      var qwe = a.replace(regex, "<");
      console.log(a.replace(regex, "<"));
      console.log(qwe.replace(regex1, ">"), "/////////////");

      console.log(a);
    }
  }
};
</script>
<style lang="less" scoped>
// .qq1{
//   background: red
// }
#qq {
  // display: inline-block;
}
.box {
  width: 100%;
}
.lef {
  float: left;
  background: #1e82d2;
  height: 930px;
  overflow-x: auto;
  width: 50%;
}
.rig {
  background: darkgray;
  height: 930px;
  overflow-x: auto;
  width: 50%;
  float: right;
}
// .${10_0} {
//   /* background: #eee; */
//   color: #1e82d2;
//   font-weight: bolder;
// }
</style>
